import React, { createContext, useState, useMemo } from "react";

export const AllProductContext = createContext();

export default function AllProductProvider({ children }) {
  const [allProduct, setAllProduct] = useState(true);

  // Memoize the context value to prevent unnecessary re-renders
  const contextValue = useMemo(
    () => ({ allProduct, setAllProduct }),
    [allProduct]
  );

  return (
    <AllProductContext.Provider value={contextValue}>
      {children}
    </AllProductContext.Provider>
  );
}
